const getCurrentStepIndex = (routes, currentStep)=>{
    return Object.keys(routes).indexOf(currentStep) + 1;
};

export { getCurrentStepIndex };
//# sourceMappingURL=get-current-step-index.js.map
